
export default {
  timeBasedRoute: {
    morning: 'Morning',
    noon: 'Noon',
    afternoon: 'Afternoon',
    evening: 'Evening',
    timeOfDay: 'Time of Day',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    month: 'Month'
  }
}
